import { useEffect, useReducer } from 'react';
import type { KeyBinding } from '../../../shared/CharacterTypes';
import { KeyBindingManager } from '../../services/KeyBindingManager';

/** The live key bindings; re-renders when the player rebinds a key, so a key glyph never goes stale. */
export function useKeyBindings(): readonly KeyBinding[] {
  const manager = KeyBindingManager.getInstance();
  const [, bump] = useReducer((n: number) => n + 1, 0);
  useEffect(() => manager.subscribe(bump), [manager]);
  return manager.getBindings();
}
